import * as React from 'react'

import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { getErrorLinkStyle, getLinkStyle, getWarningLinkStyle } from '../styles'
import { Colors } from '../theme/colors'
import Icon, { ICONS } from './Icon'

type IconVariant = keyof typeof ICONS
type BannerVariant = 'warning' | 'success' | 'error'

const Container = styled.div<{ variant?: BannerVariant }>`
  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: 1rem;
  padding: 1rem;
  border-radius: 1rem;
  color: ${props => props.theme.colors.bannerTextWarn};
  background: ${props => props.theme.colors.bannerBackgroundWarn};

  a {
    ${props => getWarningLinkStyle(props.theme)};
  }

  ${props => {
    switch (props.variant) {
      case 'success':
        return css`
          color: ${props.theme.colors.bannerTextSuccess};
          background: ${props.theme.colors.bannerBackgroundSuccess};

          a {
            ${getLinkStyle(props.theme)};
            color: ${props.theme.colors.bannerTextSuccess};
            text-decoration: underline;
          }
        `
      case 'error':
        return css`
          color: ${props.theme.colors.bannerTextError};
          background: ${props.theme.colors.bannerBackgroundError};

          a {
            ${getErrorLinkStyle(props.theme)};
          }
        `
      default:
        return
    }
  }}
`

const TextContainer = styled.div`
  display: grid;
  row-gap: 0.5rem;
  width: 100%;
`

const TitleText = styled.p`
  ${props => props.theme.typography.smallTitle};
`

const MessageText = styled.p`
  ${props => props.theme.typography.bodyText};
`

const StatusBanner: React.FC<{
  title?: React.ReactNode
  message?: React.ReactNode
  variant?: BannerVariant
  icon?: IconVariant
}> = ({ title, message, variant, icon }) => {
  const getIconColor = (): Colors => {
    switch (variant) {
      case 'success':
        return 'bannerTextSuccess'
      case 'error':
        return 'bannerTextError'
      default:
        return 'bannerTextWarn'
    }
  }

  return (
    <Container variant={variant}>
      {icon && <Icon color={getIconColor()} name={icon} width="1.5rem" height="1.5rem" />}
      <TextContainer>
        {title && <TitleText>{title}</TitleText>}
        {message && <MessageText>{message}</MessageText>}
      </TextContainer>
    </Container>
  )
}

export default StatusBanner
